module.exports = __webpack_public_path__ + "static/media/JH_web_8.2f4488c1.jpg";